module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('div', {
    staticClass: "chapter",
    attrs: {
      "id": "chapter5"
    }
  }, [_c('h1', [_c('a', {
    attrs: {
      "id": "page_17"
    }
  }), _c('a', {
    attrs: {
      "href": "#/007toc#chapter5"
    }
  }, [_vm._v("HOW TO USE THIS BOOK")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("This book is divided into six chapters, each featuring a different wedding style. Each style is broken down to its basic elements followed by simple ideas for pulling the look together, and eight to ten DIY projects. Our goal is to help you understand the vocabulary of a style, visualize how it can be carried throughout your entire wedding, and realize that vision. Keep in mind that the styles we’ve chosen to highlight are just a taste of what’s possible (believe us, it was tough to narrow them down to just six!). Each look can be made your own simply by choosing different colors, patterns, typefaces, or materials.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The projects within each chapter cover the gamut of wedding details, ranging from invitations to attire to décor. Because most of the projects can be adapted to a variety of wedding venues, times of year, themes, and seasons, we have also suggested ideas for variations at the end of each.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("At the beginning of each project, you’ll find the following handy key for helping you plan ahead, budget, and prepare to craft:")]), _vm._v(" "), _c('div', {
    staticClass: "table",
    attrs: {
      "id": "table1.1"
    }
  }, [_c('table', {
    staticClass: "key"
  }, [_c('tbody', [_c('tr', [_c('td', {
    staticClass: "boxedcells"
  }, [_c('strong', [_vm._v("LEVEL")])]), _vm._v(" "), _c('td', {
    staticClass: "boxedcells"
  }, [_vm._v("Easy")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "boxedcells"
  }, [_c('strong', [_vm._v("CATEGORY")])]), _vm._v(" "), _c('td', {
    staticClass: "boxedcells"
  }, [_vm._v("Décor")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "boxedcells"
  }, [_c('strong', [_vm._v("TIME")])]), _vm._v(" "), _c('td', {
    staticClass: "boxedcells"
  }, [_vm._v("6 to 7 hours for five 6-ft. strands")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "boxedcells"
  }, [_c('strong', [_vm._v("WHEN TO START")])]), _vm._v(" "), _c('td', {
    staticClass: "boxedcells"
  }, [_vm._v("4 to 6 weeks before the wedding")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "boxedcells"
  }, [_c('strong', [_vm._v("GROUP OR INDIVIDUAL")])]), _vm._v(" "), _c('td', {
    staticClass: "boxedcells"
  }, [_vm._v("Individual, or a small group")])]), _vm._v(" "), _c('tr', [_c('td', {
    staticClass: "boxedcells"
  }, [_c('strong', [_vm._v("BUDGET")])]), _vm._v(" "), _c('td', {
    staticClass: "boxedcells"
  }, [_vm._v("$50 to $100, depending on fabrics chosen")])])])])]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_vm._v("LEVEL, OR LEVEL OF DIFFICULTY")]), _vm._v(" "), _c('ul', {
    staticClass: "disc"
  }, [_c('li', [_vm._v("Easy. Requires little or no crafting experience—just the ability to follow instructions and use simple tools like scissors, paper punches, or a craft knife.")]), _vm._v(" "), _c('li', [_vm._v("Moderate. Takes a bit of artistic or crafting skill or at least patience and attention to detail. May also involve a more complicated series of steps.")]), _vm._v(" "), _c('li', [_vm._v("Advanced. Typically requires previous experience in a particular craft, such as sewing or printmaking. Often entails a lot of steps, some problem solving, and patience!")])]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_vm._v("CATEGORY")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The part of the wedding to which the project belongs.")]), _vm._v(" "), _c('ul', {
    staticClass: "disc"
  }, [_c('li', [_vm._v("Invitations: wedding invitations, save-the-dates, thank-you notes")]), _vm._v(" "), _c('li', [_vm._v("Décor: pom-poms and garlands, signs—can be used at the ceremony, reception, or at showers or the rehearsal dinner")]), _vm._v(" "), _c('li', [_vm._v("Attire: boutonnieres and corsages, groomsmen’s attire, bridesmaids’ attire, flower girl’s attire")]), _vm._v(" "), _c('li', [_vm._v("Ceremony: programs, ring pillows")]), _vm._v(" "), _c('li', [_vm._v("Reception: centerpieces, menus, place cards, seating cards, table numbers")]), _vm._v(" "), _c('li', [_vm._v("Favors and gifts: guest favors, welcome bags, bridal party gifts, guest book")])]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_c('a', {
    attrs: {
      "id": "page_18"
    }
  }), _vm._v("TIME")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The rough amount of time it takes to complete the project. Typically, this is estimated assuming that you follow our suggestions regarding making the project in a group or individually.")]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_vm._v("WHEN TO START")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Our suggested time line for when to start the project. Circumstances vary from wedding to wedding, so keep the following in mind as you plan your schedule:")]), _vm._v(" "), _c('h4', [_vm._v("Projects to start early")]), _vm._v(" "), _c('ul', {
    staticClass: "disc"
  }, [_c('li', [_vm._v("Complicated or labor-intensive")]), _vm._v(" "), _c('li', [_vm._v("Need to make en masse")]), _vm._v(" "), _c('li', [_vm._v("Not dependent on information that is not yet available, such as number of tables, reception hall measurements, or final guest count")]), _vm._v(" "), _c('li', [_vm._v("Not perishable")])]), _vm._v(" "), _c('h4', [_vm._v("Projects to start closer to your wedding")]), _vm._v(" "), _c('ul', {
    staticClass: "disc"
  }, [_c('li', [_vm._v("Simple")]), _vm._v(" "), _c('li', [_vm._v("Need only a few items")]), _vm._v(" "), _c('li', [_vm._v("Require last-minute information, such as final guest count, menu, or program")]), _vm._v(" "), _c('li', [_vm._v("Perishable or might get damaged if stored for a long time")])]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("It can be helpful to literally schedule each project into your calendar, with reminders in advance for decisions that need to be made to get started (e.g., confirm the menu with the caterer, order bridesmaids’ dresses, confirm final guest count, etc.).")]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_vm._v("GROUP OR INDIVIDUAL")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Here we’ve offered suggestions for whether the project is most efficiently tackled on your own or with the help of friends. Where a group is the best approach, we’ve broken the project down into stations that you can set up in advance to create a mini assembly line—this makes crafting projects go a lot more quickly, so you can have more fun while you’re at it!")]), _vm._v(" "), _c('h3', {
    staticClass: "left"
  }, [_vm._v("BUDGET")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The rough cost of making the project. The budget usually assumes that you have most of the basic crafting tools called for in the project, such as a craft knife and cutting mat, laser or inkjet printer, or sewing machine. It mainly includes materials that are unique to the project (and will be consumed by it), and it reflects the cost of making the number of multiples identified at the beginning of the project instructions. Adjust the budget if you’ll be buying any of the tools required for the first time in order to get started. Also note that material costs may vary by region and may be higher if you are ordering supplies online and paying for shipping.")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("The project key is followed by a list of materials and tools you’ll need to complete the project. These include any templates that are needed, available at "), _c('a', {
    attrs: {
      "href": "http://www.chroniclebooks.com/handmade-weddings",
      "target": "_blank"
    }
  }, [_vm._v("www.chroniclebooks.com/handmade-weddings")]), _vm._v(".")]), _vm._v(" "), _c('p', {
    staticClass: "noindent"
  }, [_vm._v("Finally, in the "), _c('span', {
    attrs: {
      "href": "#/075part8#page_246",
      "title": "Link target outside of Sample"
    }
  }, [_vm._v("Appendixes")]), _vm._v(" you’ll find more handy information, such as a wedding planning time line and checklist, instructions for how to address and mail your invitations, and a list of resources.")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-70875a50","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/013chapter5.vue
// module id = 87
// module chunks = 0